import type { ContentfulArticleGroupModel } from 'autogen/swagger/all';
import { withErrorBoundary } from 'react-error-boundary';
import ArticleCardSliderSection from './ArticleCards/ArticleCardSliderSection';
import ArticleCardGridSection from './ArticleCards/ArticleCardGridSection';

function CardLayoutRenderer({ articleGroups }: { articleGroups?: ContentfulArticleGroupModel[] }) {
    if (!articleGroups?.length) return null;

    if (articleGroups.length > 1) return <ArticleCardSliderSection articleGroups={articleGroups} />;

    if (articleGroups.length === 1) return <ArticleCardGridSection articleGroup={articleGroups[0]} />;

    return null;
}

export default withErrorBoundary(CardLayoutRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
